import React from 'react'

const FaCalendarAlt: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
   >
      <path
         d="M19 2.10303H18V1.10303C18 0.551027 17.553 0.103027 17 0.103027C16.447 0.103027 16 0.551027 16 1.10303V2.10303H8V1.10303C8 0.551027 7.553 0.103027 7 0.103027C6.447 0.103027 6 0.551027 6 1.10303V2.10303H5C2.243 2.10303 0 4.34603 0 7.10303V19.103C0 21.86 2.243 24.103 5 24.103H19C21.757 24.103 24 21.86 24 19.103V7.10303C24 4.34603 21.757 2.10303 19 2.10303ZM5 4.10303H19C20.654 4.10303 22 5.44903 22 7.10303V8.10303H2V7.10303C2 5.44903 3.346 4.10303 5 4.10303ZM19 22.103H5C3.346 22.103 2 20.757 2 19.103V10.103H22V19.103C22 20.757 20.654 22.103 19 22.103ZM17.832 13.255C18.216 13.652 18.204 14.286 17.807 14.669L13.067 19.237C12.514 19.79 11.76 20.103 10.959 20.103C10.158 20.103 9.404 19.791 8.838 19.224L6.586 17.132C6.182 16.756 6.158 16.123 6.534 15.719C6.912 15.314 7.544 15.292 7.947 15.667L10.225 17.784C10.658 18.214 11.288 18.186 11.664 17.81L16.418 13.228C16.816 12.845 17.448 12.857 17.832 13.254V13.255Z"
         fill="#FFD66B"
      />
   </svg>
)

export default FaCalendarAlt
